import React, { useEffect, useState } from 'react';
import printJS from 'print-js';

import { receivingApi } from 'api/receiving';
import { WarehouseLabelApi } from 'api/warehouseLabels';
import { Notifications } from 'shared';

import { PrintLabelsForLot } from './printPalletAndCaseTagsForLot';

const labelApi = new WarehouseLabelApi();

function PrintReceivedPalletAndCaseLabels({ includeEmptyCases = false, poMapGroupId, poMapId, type }) {
    const [notification, setNotification] = useState({ text: null, level: null });
    const [lots, setLots] = useState([]);

    useEffect(() => {
        const getLots = async () => {
            const res = poMapGroupId
                ? await receivingApi.getLotsFromPoMapGroupId(poMapGroupId, type)
                : await receivingApi.getLotsFromPoMapId(poMapId, type);
            if (!res.status) {
                setNotification({ text: res.msg, level: 'error' });
                return;
            }

            setLots(res.data.lots);
        };
        getLots();
    }, [poMapGroupId, poMapId, type]);

    const fileReaderCheck = (fr, tmpPDF) => {
        if (tmpPDF instanceof Blob) {
            fr.readAsDataURL(tmpPDF);
        } else {
            setNotification({ text: 'There was an issue printing the pdf', level: 'error' });
        }
    };

    const printCaseLabels = async (lotId, qty) => {
        const result = await labelApi.getCaseLabels({ lotID: lotId, qty });
        if (result) {
            const fr = new FileReader();
            fr.addEventListener(
                'load',
                () => {
                    const tmpPDFdata = fr.result.substr(fr.result.indexOf('base64,') + 7);
                    printJS({ printable: tmpPDFdata, type: 'pdf', base64: true });
                },
                false,
            );
            fileReaderCheck(fr, result);
        } else {
            setNotification({ text: 'There was an issue printing the pdf', level: 'error' });
        }
    };

    const printPalletLabels = async (lotId, qty) => {
        const result = await labelApi.getPalletLabelsByLotId({ lotId, qty, includeEmptyCases });
        if (result) {
            const fr = new FileReader();
            fr.addEventListener(
                'load',
                () => {
                    const tmpPDFdata = fr.result.substr(fr.result.indexOf('base64,') + 7);
                    printJS({ printable: tmpPDFdata, type: 'pdf', base64: true });
                },
                false,
            );
            fileReaderCheck(fr, result);
        } else {
            setNotification({ text: 'There was an issue printing the pdf', level: 'error' });
        }
    };

    return (
        <div style={{ textAlign: 'center', margin: '10px' }}>
            <Notifications options={notification} />
            {lots.map((lot) => (
                <PrintLabelsForLot
                    key={lot.id}
                    lot={lot}
                    printPallets={printPalletLabels}
                    printCases={printCaseLabels}
                />
            ))}
        </div>
    );
}

export { PrintReceivedPalletAndCaseLabels };
